module.exports = __webpack_public_path__ + "media/pouches/pouch--white-fill-586cd561.svg";